export default __webpack_public_path__ + "static/media/public-sector-portfolio.800294ad.svg";